module.exports = __webpack_public_path__ + "spine/market_truck.json?d99e6863bade809e2b5ab38fa2fae30a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/market_truck/market_truck.json
// module id = 1750
// module chunks = 3